import { Box, Button, Flex, Text, Title, Switch } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreItem } from '@flecto/types'
import { InputCurrency } from '@flecto/ui'

import { InputTaxesSelector, useTaxesInfo } from '../../../taxes'
import { OvertimeCharge } from '../OvertimeCharge/OvertimeCharge'
import { TableItemPricingRules } from '../TableItemPricingRules/TableItemPricingRules'
import { type Errors } from '../TableItemPricingRules/TableItemPricingRules'
import { useFormContext } from './FormItem'

export function TabPricing() {
  const form = useFormContext()
  const { t } = useTranslation('saas', { keyPrefix: 'items' })
  const { userDefaultTaxBracket } = useTaxesInfo()

  return (
    <Box>
      <Text fw={500}>{t('price.title')}</Text>
      <Text color='dimmed' mb='lg'>
        {t('price.description')}
      </Text>
      <Flex mb='md' align='center' justify='space-between'>
        <Box>
          <Text fw={500}>{t('price.taxable_label')}</Text>
          <Text color='dimmed'>{t('price.taxable_description')}</Text>
        </Box>
        <Switch
          data-testid='input-taxable'
          checked={form.values.taxable}
          onChange={(e) => {
            form.setFieldValue('taxable', e.currentTarget.checked)
          }}
        />
      </Flex>
      <InputTaxesSelector
        data-testid='input-taxes'
        disabled={!form.values.taxable}
        w={250}
        {...form.getInputProps('tax_rate')}
      />
      <Button
        disabled={!form.values.taxable}
        variant='white'
        bg='white !important'
        mt='xs'
        px={0}
        onClick={() => {
          form.setFieldValue('tax_rate', userDefaultTaxBracket.value)
        }}
      >
        {t('price.reset_to_default_tax_rate')}
      </Button>

      <TableItemPricingRules
        mt='md'
        item={form.values as unknown as CoreItem}
        onChange={(rules) => {
          form.setFieldValue('pricing_rules', rules)
        }}
        errors={form.errors as Errors}
      />

      <OvertimeCharge
        item={form.values as unknown as CoreItem}
        onChangeOvertime={(overtime, overtime_rule) => {
          form.setFieldValue('overtime_enabled', overtime)
          form.setFieldValue('pricing_rule_overtime', overtime_rule)
        }}
        error={form.getInputProps('pricing_rule_overtime.price_cents')?.error}
      />

      <Box mt='xl'>
        <Title mb='md' order={4}>
          {t('price.other_settings')}
        </Title>
        <Flex direction='column' gap='sm'>
          <Flex direction='column'>
            <Text size='md'>{t('price.field_deposit.title')}</Text>
            <Text fw='normal' color='dimmed' size='sm'>
              {t('price.field_deposit.description')}
            </Text>
          </Flex>
          <InputCurrency
            w={200}
            data-testid='input-deposit_amount'
            {...form.getInputProps('deposit_amount')}
          />
        </Flex>
      </Box>
    </Box>
  )
}
